<template>
    <div>
        <v-card v-if="selection === 'text' || selection === 'نص'" elevation="0">
            <v-card-subtitle>
                <v-list>
                    <draggable v-model="items" @end="onDragEnd" :options="draggableOptions">
                        <v-list-item v-for="(item, index) in items" :key="index" class="item-list">
                            <v-list-item-icon>
                                <v-icon>mdi-drag</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{item}}</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                                <CustomVselect v-model="itemPosition[index]"
                                               :items="positionOptions"
                                               :tabindex="0"
                                               @input="handlePositionChange(index)"></CustomVselect>
                                <!--<v-select v-model="itemPosition[index]"
                                :items="positionOptions"
                                @change="handlePositionChange(index)"
                                dense
                                solo
                                :key="'select_' + index"
                                class="CustomRank"></v-select>-->
                            </v-list-item-action>
                        </v-list-item>
                    </draggable>
                </v-list>
            </v-card-subtitle>
        </v-card>
        <v-card v-if="selection === 'image' || selection === 'صورة'">

            <v-card-subtitle>
                <v-list>
                    <draggable v-model="items"
                               @end="onDragEnd"
                               :options="draggableOptions">
                        <v-list-item v-for="(item, index) in items"
                                     :key="index"
                                     class="item-list">
                            <v-list-item-icon>
                                <v-icon>mdi-drag</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title><!--<v-img :src="item.split('&')[1]" max-height="200" contain class="my-2"></v-img>--></v-list-item-title>
                                <v-list-item-title><v-img :src="item.split('&')[1]" max-height="200" contain class="my-2"></v-img></v-list-item-title>
                                <v-list-item-title>{{item.split('&')[0]}}</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                                <CustomVselect v-model="itemPosition[index]"
                                               :items="positionOptions"
                                               :tabindex="0"
                                               @input="handlePositionChange(index)"></CustomVselect>
                                <!--<v-select v-model="itemPosition[index]"
                                :items="positionOptions"
                                @change="handlePositionChange(index)"
                                dense
                                solo
                                :key="'select_' + index"
                                class="CustomRank"></v-select>-->
                            </v-list-item-action>
                        </v-list-item>
                    </draggable>
                </v-list>
            </v-card-subtitle>
        </v-card>
    </div>
</template>

<script>
    import draggable from 'vuedraggable'
    import CustomVselect from '@/components/controls/CustomVselect.vue'

    export default {
        components: {
            draggable, CustomVselect
        },
        props: {
            value: {
                type: String,
                default: ''
            },
            options: {
                type: String,
                default: ''
            }
        },
        data() {


            return {
                selection: this.extractType(this.options),
                items: [],
                itemPosition: [],
                initialPosition: [],
                draggableOptions: {
                    animation: 200,
                    handle: '.v-list-item'
                }
            }
        },
        computed: {
            positionOptions() {

                return this.getPositionOptions(this.items.length)
            }
        },
        mounted() {

            /*this.items = this.extractItems(this.options)
            this.initialPosition = this.initializePosition(initialItems.length)
            this.itemPosition = [...initialPosition]*/
            let newItems = this.extractItems(this.value)
            let selection = this.extractType(this.value)
            if (!newItems && this.options) {
                newItems = this.extractItems(this.options)
                selection = this.extractType(this.options)
            }
            if (newItems && newItems.length) {
                this.selection = selection || this.selection
                this.items = [...newItems]
                this.itemPosition = this.initializePosition(newItems.length)
                this.initialPosition = [...this.itemPosition]
                this.$nextTick(() => this.emitData())
            }
        },
        watch: {
            value: {
                handler: function (newValue, oldVal) {
                    const newItems = this.extractItems(newValue)
                    this.selection = this.extractType(newValue)
                    this.items = [...newItems]
                    this.itemPosition = this.initializePosition(newItems.length)
                    this.initialPosition = [...this.itemPosition]
                },
                deep: true
            }
        },
        methods: {
            extractType(value) {
                if (value) {
                    const type = value.split('#')[0]
                    return type === 'text' || type === 'نص' ? 'text' : 'image'
                }
            },
            extractItems(value) {
                if (value) {
                    const parts = value.split('#')
                    if (parts[0] === 'text' || parts[0] === 'نص') {
                        return parts[1] ? parts[1].split('$') : []
                    } else if (parts[0] === 'image' || parts[0] === 'صورة') {

                        return parts[1] ? parts[1].split('$') : []
                    }
                }
            },
            initializePosition(length) {
                let itemPos = Array.from({ length }, (_, i) => i + 1)

                return itemPos
            },
            getPositionOptions(length) {
                return Array.from({ length }, (_, i) => ({
                    id: i + 1,
                    value: `${i + 1}`,
                }))
            },
            handlePositionChange(index) {
                const newIndex = this.itemPosition[index] - 1

                this.swapItems(index, newIndex)

            },

            swapItems(fromIndex, toIndex) {
                if (fromIndex === toIndex) return

                const items = [...this.items]
                const itemPositions = [...this.itemPosition]
                const initItemPositions = [...this.itemPosition]

                const tempItem = items[fromIndex]
                items[fromIndex] = items[toIndex]
                items[toIndex] = tempItem

                const tempPosition = itemPositions[fromIndex]
                itemPositions[fromIndex] = itemPositions[toIndex]
                itemPositions[toIndex] = tempPosition

                this.items = items
                this.itemPosition = itemPositions


                //const updatedPositions = [...this.itemPosition]
                //console.log('updatedPositions', updatedPositions)
                //// Remove the previous value at the changed index
                //const previousValue = updatedPositions[fromIndex]
                //updatedPositions.splice(fromIndex, 1, toIndex)
                //console.log('updatedPositions2', updatedPositions)
                //console.log('updatedPositions2', fromIndex)
                //console.log('updatedPositions2', toIndex)
                //// Check for duplicates and adjust values to ensure uniqueness
                //const uniqueValues = Array.from(new Set(updatedPositions))
                //console.log('uniqueValues', uniqueValues)
                //const filledPositions = uniqueValues.concat(
                //    Array.from({ length: this.positionOptions.length - uniqueValues.length }, (_, i) => i + 1)
                //)

                //console.log('filledPositions', filledPositions)
                //// Update the itemPosition array
                //this.itemPosition = filledPositions.slice(0, this.positionOptions.length)


                this.updatePositions()

                //const ar = initItemPositions.reverse()
                ////const newOrder = this.items.sort((a, b) => a - b);
                //this.itemPosition = ar
                ////this.itemPosition = newOrder
            },

            resetSelect() {
                console.log('reset')
                this.itemPosition = [...this.initialPosition]
            },

            emitData() {
                const data = this.items.join('$')
                console.log(this.items)
                this.$emit('input', `${this.selection}#${data}`)
            },

            onDragEnd(event) {
                this.updatePositions()
            },
            updatePositions() {
                this.itemPosition = this.items.map((_, index) => index + 1)
                this.emitData()
            },
            handleInput(value) {
                console.log('Selected value:', value)
                this.selectedOption = value // Handle input event
            }

        },

    }
</script>

<style scoped>
    .item-list {
        border: 1px solid var(--v-primary-base);
        border-radius: 10px;
        margin: 5px 0;
        display: flex;
        align-items: center;
    }

    .CustomRank {
        border: 1px solid var(--v-primary-base);
        height: 40px;
        border-radius: 20px;
        width: 71px;
    }
</style>
